var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99988 1.66669C10.4601 1.66669 10.8332 2.03978 10.8332 2.50002V10.4882L13.5773 7.7441C13.9027 7.41866 14.4304 7.41866 14.7558 7.7441C15.0812 8.06954 15.0812 8.59717 14.7558 8.92261L10.5891 13.0893C10.2637 13.4147 9.73606 13.4147 9.41063 13.0893L5.24396 8.92261C4.91852 8.59717 4.91852 8.06954 5.24396 7.7441C5.5694 7.41866 6.09704 7.41866 6.42247 7.7441L9.16655 10.4882V2.50002C9.16655 2.03978 9.53965 1.66669 9.99988 1.66669ZM2.49988 11.6667C2.96012 11.6667 3.33322 12.0398 3.33322 12.5V15.8334C3.33322 16.0544 3.42101 16.2663 3.57729 16.4226C3.73357 16.5789 3.94554 16.6667 4.16655 16.6667H15.8332C16.0542 16.6667 16.2662 16.5789 16.4225 16.4226C16.5788 16.2663 16.6666 16.0544 16.6666 15.8334V12.5C16.6666 12.0398 17.0396 11.6667 17.4999 11.6667C17.9601 11.6667 18.3332 12.0398 18.3332 12.5V15.8334C18.3332 16.4964 18.0698 17.1323 17.601 17.6011C17.1321 18.07 16.4963 18.3334 15.8332 18.3334H4.16655C3.50351 18.3334 2.86762 18.07 2.39878 17.6011C1.92994 17.1323 1.66655 16.4964 1.66655 15.8334V12.5C1.66655 12.0398 2.03965 11.6667 2.49988 11.6667Z",
    fill: "#0070B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.12d648ff1f5068ce0a843673cc72a043.svg";
export { ForwardRef as ReactComponent };